import React, { useRef, useEffect, useState } from 'react';

const ProfileProgress = ({ completedLessons, totalLessons }) => {
    const [blocksCount, setBlocksCount] = useState(0);
    const [animatingBlocks, setAnimatingBlocks] = useState(0);
    const [showSuccessAnimation, setShowSuccessAnimation] = useState(false);
    const progressBarRef = useRef(null);
    const animationTimerRef = useRef(null);

    useEffect(() => {
        if (progressBarRef.current) {
            const barWidth = progressBarRef.current.offsetWidth;
            const possibleBlocks = Math.floor(barWidth / 8);
            setBlocksCount(possibleBlocks);
        }

        return () => {
            if (animationTimerRef.current) {
                clearInterval(animationTimerRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (blocksCount > 0 && completedLessons > 0) {
            const progress = (completedLessons / totalLessons);
            const targetBlocks = Math.ceil(progress * blocksCount);
            setShowSuccessAnimation(false);

            if (animationTimerRef.current) {
                clearInterval(animationTimerRef.current);
            }

            let currentBlock = 0;
            setAnimatingBlocks(0);

            setTimeout(() => {
                animationTimerRef.current = setInterval(() => {
                    if (currentBlock < targetBlocks) {
                        currentBlock++;
                        setAnimatingBlocks(currentBlock);
                    } else {
                        clearInterval(animationTimerRef.current);
                        // Если достигли 100%, запускаем анимацию успеха
                        if (completedLessons === totalLessons) {
                            setTimeout(() => {
                                setShowSuccessAnimation(true);
                            }, 500); // Небольшая пауза перед сменой цвета
                        }
                    }
                }, 50);
            }, 1000);
        }
    }, [blocksCount, completedLessons, totalLessons]);

    const progressPercentage = Math.round((completedLessons / totalLessons) * 100);

    return (
        <div className="profile-progress-container">
            <div className="progress-background">
                <div className="background-rect"></div>
                <svg className="corner top-left" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M34 2H13.6364L2 12.2655V31" stroke="#00739F" strokeWidth="3" strokeMiterlimit="10" />
                </svg>
                <svg className="corner top-right" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 2H36.3636L48 12.2655V31" stroke="#00739F" strokeWidth="3" strokeMiterlimit="10" />
                </svg>
                <svg className="corner bottom-left" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M34 48H13.6364L2 37.7345V19" stroke="#00739F" strokeWidth="3" strokeMiterlimit="10" />
                </svg>
                <svg className="corner bottom-right" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 48H36.3636L48 37.7345V19" stroke="#00739F" strokeWidth="3" strokeMiterlimit="10" />
                </svg>
            </div>
            <div className="progress-content">
                <div className="progress-title">ПРОГРЕСС</div>
                <div className="progress-wrapper">
                    <div className="progress-bar-container">
                        <div className="progress-bar" ref={progressBarRef}>
                            {[...Array(blocksCount)].map((_, index) => (
                                <div
                                    key={index}
                                    className={`progress-block ${index <= animatingBlocks ? 'filled' : ''
                                        } ${showSuccessAnimation && index <= animatingBlocks ? 'success' : ''
                                        }`}
                                />
                            ))}
                        </div>
                    </div>
                    <div className="progress-text">
                        {progressPercentage}%
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileProgress; 